import * as React from "react";

type ToastMessage = {
  id: string;
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  variant?: "default" | "destructive";
};

let toasts: ToastMessage[] = [];
const listeners: Array<(next: ToastMessage[]) => void> = [];

function notify() {
  for (const l of listeners) l([...toasts]);
}

export function toast(
  opts: Omit<ToastMessage, "id"> & { id?: string }
) {
  const id = opts.id ?? Math.random().toString(36).slice(2);
  const next: ToastMessage = { id, ...opts };
  toasts = [...toasts, next];
  notify();
  // Auto-dismiss after 5s
  setTimeout(() => {
    toasts = toasts.filter((t) => t.id !== id);
    notify();
  }, 5000);
  return { id };
}

export function useToast() {
  const [state, setState] = React.useState<ToastMessage[]>(toasts);

  React.useEffect(() => {
    const listener = (next: ToastMessage[]) => setState(next);
    listeners.push(listener);
    return () => {
      const idx = listeners.indexOf(listener);
      if (idx > -1) listeners.splice(idx, 1);
    };
  }, []);

  return {
    toasts: state,
    toast,
  };
}